import React from "react";
import { QRCodeSVG } from "qrcode.react";
import { Card, Tooltip, Typography } from "@mui/material";
import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import { useMaterialUIController } from "context";
import { useSelector } from "react-redux";
import { getSession } from "services/service";

const QRCodeComponent = ({ size = 150 }) => {
  const meUserInfo = useSelector((state) => state.users.meInfo);
  const userId = meUserInfo._id;
  const { Authorization } = getSession();
  console.log("Authorization >>>>>>> ", Authorization);
  console.log("userId >>>>>>> ", userId);
  const url = `https://production.d1q1osbygackda.amplifyapp.com/?userId=${userId}&token=${Authorization}`;
  const logoUrl = new URL(url).searchParams.get("logoUrl");

  const handleOpenInNewTab = () => {
    window.open(url, "_blank");
  };
  const [controller] = useMaterialUIController();
  const { sidenavColor } = controller;

return (
  <MDBox
    // p={1}
    display="flex"
    justifyContent="center"   
    alignItems="center"
    sx={{
      width: "100%",
      height: "100%",
      margin: 0,
    }}
  >
    
    <MDBox
      display="flex"
      flexDirection="column"
      alignItems="center"
      width={150}
    >
      
      <MDBox position="relative">
        <QRCodeSVG value={url} size={size} level="H" includeMargin />

        {logoUrl && (
          <img
            src={logoUrl}
            alt="Logo"
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width:80,
              height: 25,
              backgroundColor: "white",
              borderRadius: "4px",
              padding: 2,
            }}
          />
        )}
      </MDBox>

      <MDBox width="100%" >
        <Tooltip
          title="Click to open the verification page where you can enter your license plate and view its current status."
          placement="top"
          arrow
        >
          <MDButton
            onClick={handleOpenInNewTab}
            variant="gradient"
            color={sidenavColor}
            fullWidth   
           size="medium"
            sx={{ fontSize: "10px", padding: "4px" }}
          >
            Verify Vehicle
          </MDButton>
        </Tooltip>
       
      </MDBox>
     
    </MDBox>
     
  </MDBox>
);
};

export default QRCodeComponent;